import React from 'react';
import { ReactComponent as NavigationButtonSvg } from '../icons/navigation_button.svg';
import styles from './NavigationButtons.module.css';

export const ButtonBackSvg: React.FC = () => {
    return <NavigationButtonSvg className={styles.navigationButtonBackIcon} />;
};

export const ButtonNextSvg: React.FC = () => {
    return <NavigationButtonSvg className={styles.navigationButtonNextIcon} />;
};
